import { render, staticRenderFns } from "./worship.vue?vue&type=template&id=235eea56&scoped=true"
import script from "./worship.vue?vue&type=script&lang=js"
export * from "./worship.vue?vue&type=script&lang=js"
import style0 from "./worship.vue?vue&type=style&index=0&id=235eea56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235eea56",
  null
  
)

export default component.exports